import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { MapPin, IMapPinProps } from '@hotelplan/components.common.map-pin';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { FdrProductPin } from 'fdr/components/local/fdr-srl-map/fdr-srl-map.types';

interface IFdrSrlMapProductPinProps
  extends Omit<IMapPinProps<FdrProductPin>, 'coordinates' | 'object'> {
  offer: FdrProductPin;
}

const FdrProductPinContent = styled.div({
  display: 'flex',
  alignItems: 'center',
});

const FdrTopProductIcon = styled(BsIcon).attrs({ size: 'lg', name: 'top' })(
  sx2CssThemeFn({
    display: 'inline-block',
    pr: 2,
    my: -4,
  })
);

const FdrProductPrice = styled.div({
  whiteSpace: 'nowrap',
});

export const FdrSrlMapProductPin: React.FC<IFdrSrlMapProductPinProps> =
  props => {
    const { offer, ...mapPinProps } = props;
    const [t] = useTranslation('results');

    if (offer.product.__typename !== 'FdrHotel') return null;
    const isTop = offer.product?.flags.top;

    return (
      <MapPin<FdrProductPin>
        coordinates={offer.product.coordinates}
        object={offer}
        {...mapPinProps}
      >
        <FdrProductPinContent>
          {isTop ? <FdrTopProductIcon /> : null}
          <FdrProductPrice>
            {t('results:price.from', {
              price: `${
                offer.pricePerPerson.currency
              } ${offer.pricePerPerson.value.toString()}`,
            })}
          </FdrProductPrice>
        </FdrProductPinContent>
      </MapPin>
    );
  };
